export function roundNumber(value: number, decimalPlaces: number) {
  return value.toFixed(decimalPlaces);
}